import { Hero } from "@/pages/sections/Hero";
import { Marquee } from "@/pages/sections/Marquee";
import { Problem } from "@/pages/sections/Problem";
import { BuildEngine } from "@/pages/sections/BuildEngine";
import { Proof } from "@/pages/sections/Proof";
import { InBuildNow } from "@/pages/sections/InBuildNow";
import { ExpertiseBand } from "@/pages/sections/ExpertiseBand";
import { Compliance } from "@/pages/sections/Compliance";
import { Vision2040 } from "@/pages/sections/Vision2040";
import { Industries } from "@/pages/sections/Industries";
import { About } from "@/pages/sections/About";
import { WhyChooseUs } from "@/pages/sections/WhyChooseUs";
import { ContactForm } from "@/pages/sections/ContactForm";
import { WhatHappensNext } from "@/pages/sections/WhatHappensNext";
import { Insights } from "@/pages/sections/Insights";
import { ClosingCTA } from "@/pages/sections/ClosingCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Problem />
      <BuildEngine />
      <Proof />
      <InBuildNow />
      <ExpertiseBand />
      <Compliance />
      <Vision2040 />
      <Industries />
      <About />
      <WhyChooseUs />
      <ContactForm />
      <WhatHappensNext />
      <Insights />
      <ClosingCTA />
    </div>
  );
}
